export default {"src":"/_next/static/media/phone-icon.b2dd452d.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};